<template>
  <div v-if="loaded" id="app">
    <div v-if="!!user" id="nav">
      <router-link to="/" v-if="!admin">
        Главная
      </router-link>
      <router-link to="/admissions" v-if="!admin">
        Заявки
      </router-link>
      <router-link to="/specialties" v-if="!admin">
        Специальности
      </router-link>
      <router-link to="/news" v-if="!admin">
        Новости
      </router-link>
      <router-link to="/rules" v-if="!admin">
        Правила приема
      </router-link>
      <router-link to="/preparatory" v-if="!admin">
        Подготовительные курсы
      </router-link>
      <router-link to="/admin" v-if="admin">
        Админ
      </router-link>

      <span v-on:click="handleSignOut">
        Выйти
      </span>
    </div>
    <div id="body">
      <router-view/>
    </div>
  </div>
  <Spin v-else size="large" fix/>
</template>

<script>
// TODO MANY_TO_MANY ADMIN - INSTITUTION
// TODO VUEX WITH INSTITUTION
// TODO NO INSTITUTION FOUND
// TODO PERMISIONS IN HALL PROJECT
import firebase from 'firebase/app';
import 'firebase/auth';

export default {
  data() {
    return {
      user: null,
      loaded: false,
      admin: false
    }
  },
  mounted() {
    firebase.auth().onAuthStateChanged(async user => {
      if(!user) {
        if(this.$route.path !== '/admin') {
          this.$router.push('/auth');
        }
      }
      else {
        //TODO PERMISSION DENIED
        const admin = (await firebase.database().ref(`admin`).once('value')).val();

        if(admin === user.email) {
          this.admin = true;
          this.$router.push('/admin');
        }
        else {
          this.admin = false;
        }
      }

      this.user = user;
      this.loaded = true;
    });
  },
  methods: {
    async handleSignOut() {
      this.$Modal.confirm({
        title: 'Выход',
        content: "Вы уверены, что хотите выйти из учетной записи?",
        onOk: async () => {
          await firebase.auth().signOut();

          this.$router.push('/auth');
        }
      })
    }
  }
}
</script>


<style>
html, body, #app {
  height: 100%;
}
#app {
  background: #f8f8f9;
  overflow: auto;
}
#body {
  margin: auto;
  max-width: 800px;
  padding: 16px;
  overflow: auto;
}
#nav {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  font-size: 14px;
  margin-bottom: 8px;
  padding: 16px 32px;
  background: #fff;
  box-shadow: 0 1px 1px rgba(0,0,0,.08);
}
#nav a {
  /* font-weight: bold; */
  margin-right: 16px;
  color: #464c5b;
}
#nav a.router-link-exact-active {
  font-weight: bold;
  color: #2d8cf0;
}
#nav a.router-link-exact-active:hover {
  color: #57a3f3;
}
#nav span {
  cursor: pointer;
  color: #9ea7b4;
}
.ivu-form-item {
  margin-bottom: 16px !important;
}
.ivu-form-item:last-child {
  margin-bottom: 0 !important;
}
.ivu-form .ivu-form-item-label {
  padding: 0 !important;
  margin-bottom: 8px;
}
</style>
